import React from 'react';

import { useLocation } from 'react-router-dom';

import Box from '@amzn/meridian/box';
import BreadCrumbs from 'src/components/shared/breadcrumbs/breadcrumbs';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';

import './adminConfiguration.scss';

import JobModificationConfig from './modificationConfig/modificationConfig';
import NonPhysicalTaskConfiguration from './nonPhysicalTaskConfiguration/nonPhysicalTaskConfig';
import RestrictionFormConfiguration from './restrictionFormConfiguration/restrictionFormConfiguration';
import SiteConfiguration from './siteConfiguration/siteConfiguration';
import TabGroup from './tabGroup/tabGroup';
import TaskConfiguration from './taskConfiguration/taskConfiguration';

// **** Components **** //

/**
 * Default configuration
 */
const AdminConfiguration = () => {
  const location = useLocation();
  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <div className="admin-configuration">
      <BreadCrumbs
        breadcrumbList={[
          { label: 'Return To Work 2.0', url: '/' },
          { label: 'Admin Portal', url: AdminConfigPaths.root },
        ]}
      />
      <div className="admin-configuration__tab-group">
        <TabGroup />
      </div>
      <Box type="outline" spacingInset="200 500 400 500" className="admin-configuration__content">
        {isSelected(AdminConfigPaths.SITE) ? (
          <SiteConfiguration />
        ) : isSelected(AdminConfigPaths.Task.root) ? (
          <TaskConfiguration />
        ) : isSelected(AdminConfigPaths.NonPhysicalTask) ? (
          <NonPhysicalTaskConfiguration />
        ) : isSelected(AdminConfigPaths.Form.root) ? (
          <RestrictionFormConfiguration />
        ) : isSelected(AdminConfigPaths.MODIFICATION) ? (
          <JobModificationConfig />
        ) : null}
      </Box>
    </div>
  );
};

// **** Export **** //

export default AdminConfiguration;
